import React from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import DOMPurify from 'dompurify';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Grid } from 'semantic-ui-react';
import { withAnalytics } from '../../analytics';
import { GridNumbers } from '../../utils';

// made specific to the image and content grid
const StreamSliderGrid = ({ intl, item, analytics }) => {
  const generateOnNewsItemClick = (title, url) => () => {
    analytics.trackEvent('News item clicked', {
      'News Item Title': title,
      'News Item URL': url
    });
  };

  return (
    <Grid>
      <Grid.Column mobile={GridNumbers.base} computer={GridNumbers.half}>
        <figure className="streamslider__img">
          <img src={item.imageUrl} alt={item.name} />
        </figure>
      </Grid.Column>

      <Grid.Column
        as="article"
        mobile={GridNumbers.base}
        computer={GridNumbers.half}
        className="streamslider__content"
      >
        <h2 className="text--header">
          <FormattedMessage
            id="title.news"
            description="News intro content"
            defaultMessage="News for {year}!"
            values={{ year: new Date().getFullYear() }}
          />
        </h2>
        {item.name && <h3>{item.name}</h3>}
        {Parser(DOMPurify.sanitize(item.newsDescription))}
        <a
          href={item.newsLink}
          onClick={generateOnNewsItemClick(item.name, item.newsLink)}
          title={intl.formatMessage({
            id: 'cta.findout_more',
            defaultMessage: 'Find out more'
          })}
        >
          <strong>
            <FormattedMessage
              id="cta.findout_more"
              description="Find out more link label"
              defaultMessage="Find out more"
            />
          </strong>
        </a>
      </Grid.Column>
    </Grid>
  );
};

StreamSliderGrid.propTypes = {
  intl: intlShape.isRequired,
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    newsDescription: PropTypes.string,
    url: PropTypes.string,
    imageUrl: PropTypes.string
  }),
  analytics: PropTypes.object
};

export default withAnalytics(injectIntl(StreamSliderGrid));
